import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WtfConfigService } from '../../services/core/config.service';
import { Subscription } from 'rxjs';

@Component({
    selector   : 'wtf-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls  : ['./search-bar.component.scss']
})
export class WtfSearchBarComponent implements OnInit
{
    collapsed: boolean;
    toolbarColor: string;
    @Output() onInput: EventEmitter<any> = new EventEmitter();
    onSettingsChanged: Subscription;

    constructor(
        private wtfConfig: WtfConfigService
    )
    {
        this.collapsed = true;
        this.onSettingsChanged =
            this.wtfConfig.onSettingsChanged
                .subscribe(
                    (newSettings) => {
                        this.toolbarColor = newSettings.colorClasses.toolbar;
                    }
                );
    }

    ngOnInit()
    {

    }

    collapse()
    {
        this.collapsed = true;
    }

    expand()
    {
        this.collapsed = false;
    }

    search(event)
    {
        const value = event.target.value;

        this.onInput.emit(value);
    }

}
